import {
  Actions,
  ConnectionState,
} from 'ha/modules/RealtimeMessaging/constants';

export default action =>
  action.type === Actions.REALTIME_CONNECTION_UPDATED &&
  action.payload === ConnectionState.connected;
